<template>
  <div v-if="isProductsAvailable" class="related-products">
    <h2 class="mb-5">Sản phẩm liên quan</h2>
    <div class="products">
      <VueSlickCarousel v-bind="settings" :focusOnSelect="true">
        <template v-for="product in products">
          <div class="px-2" :key="product.id">
            <ProductCard :product="product" />
          </div>
        </template>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import ProductCard from "./ProductCard.vue";

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  props: {
    products: {
      type: Array,
      default: [],
    },
  },
  components: {
    ProductCard,
    VueSlickCarousel,
  },
  data() {
    return {
      settings: {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        responsive: [
          {
            breakpoint: 1366,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
            },
          },
        ],
      },
    };
  },
  computed: {
    isProductsAvailable() {
      return this.products.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.related-products {
  margin-top: 100px;
  padding-bottom: 200px;
}
/* the slides */
::v-deep .slick-slide {
  margin: 0 27px;
}

/* the parent */
::v-deep .slick-list {
  margin: 0 -27px;
  height: 446px !important;
}
@media screen and (max-width: 1660px) and (min-width: 1279px) {
  .related-products {
    margin-top: 80px;
    padding: 0 80px 150px 80px;
  }
}
@media screen and (max-width: 1279px) and (min-width: 769px) {
  .related-products {
    margin-top: 60px;
    padding: 0 60px 120px 60px;
  }
}
@media screen and (max-width: 768px) and (min-width: 481px) {
  .related-products {
    margin-top: 40px;
    padding: 0 40px 80px 40px;
  }
}
@media screen and (max-width: 480px) and (min-width: 0) {
  ::v-deep .slick-list {
    margin: initial;
    height: 475px !important;
  }
  ::v-deep .slick-slide {
    margin: initial;
  }
}
</style>
